<div id="top-nav" class="d-flex flex-row">
  <div class="logo-container p-1">
    <a routerLink="exam-reports"><img id="logo-img" src="/assets/fekete_kek_ikon.png" alt="KVAR" /></a>
  </div>
  <div class="d-flex flex-grow-1 align-items-center justify-content-center">
    <h2 class="text-center">{{ title }}</h2>
  </div>
  <div *ngIf="hasRole && !isLoading" class="d-flex justify-content-center align-items-center">
    <div class="flex-column">
      <div class="user-name">
        {{this.userName}}
      </div>
      <ng-select [clearable]="false" class="tenant-select" placeholder="Válasszon ki egy területet" [(ngModel)]="selectedTenantId">
        <ng-option *ngFor="let option of tenantSelectList.items" [value]="option.value">
          {{ option.text }}
        </ng-option>
      </ng-select>
    </div>
  </div>
  <div class="ms-auto d-flex align-items-center me-3">
    <ul class="navbar-nav">
      <li class="nav-item" (click)="logout()">
        <span class="material-icons icon-large">logout</span>
      </li>
    </ul>
  </div>
</div>
